<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VAXoSE/images/9781488091452.jpg?1705359744467" alt="This image is the cover for the book Yuletide Homecoming, A Snowglobe Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Yuletide Homecoming, A Snowglobe Christmas
      </h1>
      <p class="bookDescription body article font2">
        <b>In the <i>New York Times</i>–bestselling author’s heartwarming holiday romance, a soldier’s return to Montana rekindles a love that’s meant to last.</b><br/><br/>Five years ago, Rafe Westfield broke his fiancée’s heart when he left to join the military. Now the battle-scarred soldier is back in Snowglobe, Montana, and Amy Caldwell knows a broken heart isn’t what she wants for Christmas. But trying to keep her distance is nearly impossible, thanks to the spirit of the season, a well-meaning family, and a sweet stray dog who keeps bringing her and Rafe together. Maybe this time forever . . . <br/><br/><i>Yuletide Homecoming</i> was originally published in 2012 as part of the 2-in-1 anthology, <i>A Snowglobe Christmas</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Goodnight
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today Bestseller, Linda Goodnight is the winner of the RITA and other highly acclaimed awards for her&#160;emotional&#160;fiction. Active in orphan ministry, this former nurse and teacher enjoys writing fiction that carries a message of hope and light in a sometimes dark world. A country girl, she lives in Oklahoma. Readers may contact her through her website: <a href="http://www.lindagoodnight.com">www.lindagoodnight.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?51095f2a